import {
  ChevronLeftIcon,
  extendTheme,
  NativeBaseProvider,
  Pressable,
} from "native-base";
import { Provider } from "react-redux";
import Home from "./components/Home";
import Detail from "./components/Detail";
import { store } from "./store/store";
import { StyleSheet, View } from "react-native";
import { QueryClient, QueryClientProvider } from "react-query";
import { NavigationContainer } from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { useState } from "react";
import * as Font from "expo-font";
import AppLoading from "expo-app-loading";
import Colors from "./const/Colors";
import { getDeviceLanguageCode } from "./util/LanguageUtil";
import { useTranslation } from "react-i18next";
import { onBackPressed } from "./util/JsInterfaceUtil";
import LoadingView from "./components/element/LoadingView";
import Edit from "./components/Edit";
import Result from "./components/Result";
import { getInitRoute } from "./util/CookieUtil";
import {
  NotoSansJP_400Regular,
  NotoSansJP_700Bold,
} from "@expo-google-fonts/noto-sans-jp";

const queryClient = new QueryClient();
const Stack = createNativeStackNavigator();

const getFontsAsync = async (languageCode: string) => {
  let fonts = {
    appFontRegular: NotoSansJP_400Regular,
    appFontBold: NotoSansJP_700Bold,
    appFontItalic: NotoSansJP_400Regular,
  };
  await Font.loadAsync(fonts);
};

export default function App(props: any) {
  const { t } = useTranslation();

  const theme = extendTheme({
    fontConfig: {
      appFont: {
        100: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
        200: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
        300: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
        400: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
        500: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
        600: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
        700: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
        800: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
        900: {
          normal: "appFontRegular",
          italic: "appFontItalic",
          bold: "appFontBold",
        },
      },
    },
    fonts: {
      heading: "appFont",
      body: "appFont",
      mono: "appFont",
    },
    colors: {
      radioPrimary: {
        50: Colors.white,
        100: Colors.primaryColor,
        200: Colors.primaryColor,
        300: Colors.primaryColor,
        400: Colors.primaryColor,
        500: Colors.primaryColor,
        600: Colors.primaryColor,
        700: Colors.primaryColor,
        800: Colors.primaryColor,
        900: Colors.primaryColor,
      },
    },
    components: {
      Radio: {
        defaultProps: {
          colorScheme: "radioPrimary",
        },
      },
    },
  });

  const [isFontsReady, setFontsReady] = useState(false);

  const loadFontAsync = async () => {
    await getFontsAsync(getDeviceLanguageCode());
  };

  if (!isFontsReady) {
    // ppw('ApplicationNavigator().isFontsReady', isFontsReady)
    return (
      <NativeBaseProvider>
        <View
          style={{
            flex: 1,
            // backgroundColor: Colors.redError,
          }}
        >
          <LoadingView isOpen={true} />
          <AppLoading
            startAsync={loadFontAsync}
            onFinish={() => setFontsReady(true)}
            onError={() => {}}
          />
        </View>
      </NativeBaseProvider>
    );
  }

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <NativeBaseProvider theme={theme}>
          <NavigationContainer style={styles.container}>
            <Stack.Navigator initialRouteName={getInitRoute().initPage}>
              <Stack.Screen
                name={"HealthCheck"}
                component={Home}
                options={{
                  title: t("Health Check") ?? "",
                  navigationBarColor: "white",
                  headerShadowVisible: false,
                  headerStyle: {
                    backgroundColor: "white",
                  },
                  headerTitleStyle: {
                    fontWeight: "bold",
                    fontSize: 20,
                  },
                  headerTitleAlign: "center",
                  headerTintColor: Colors.black,
                  headerLeft: () => (
                    <Pressable
                      onPress={() => {
                        onBackPressed();
                      }}
                    >
                      <ChevronLeftIcon
                        size="5"
                        mt="0.5"
                        marginLeft={4}
                        color={Colors.black}
                      />
                    </Pressable>
                  ),
                  // headerRight: () => (
                  //   <Pressable
                  //     onPress={() => {
                  //       openGlossary("po_health_check");
                  //     }}
                  //   >
                  //     <ImageMenu
                  //       mr={10}
                  //       uri={
                  //         "https://s3.ap-northeast-1.amazonaws.com/real.genki.uploads/RN_Uploads/ic_bulb.png"
                  //       }
                  //     />
                  //   </Pressable>
                  // ),
                }}
              />

              <Stack.Screen
                name={"Detail"}
                component={Detail}
                options={({ navigation, route }) => ({
                  title: "",
                  navigationBarColor: "white",
                  headerShadowVisible: false,
                  headerStyle: {
                    backgroundColor: "white",
                  },
                  headerTitleStyle: {
                    fontWeight: "bold",
                    fontSize: 20,
                  },
                  headerTitleAlign: "center",
                  headerTintColor: Colors.black,
                  headerLeft: () => (
                    <Pressable
                      onPress={() => {
                        navigation.goBack();
                      }}
                    >
                      <ChevronLeftIcon
                        size="5"
                        mt="0.5"
                        marginLeft={4}
                        color={Colors.black}
                      />
                    </Pressable>
                  ),
                })}
              />
              <Stack.Screen
                name={"Edit"}
                component={Edit}
                options={({ navigation, route }) => ({
                  title: "",
                  navigationBarColor: "white",
                  headerShadowVisible: false,
                  headerStyle: {
                    backgroundColor: "white",
                  },
                  headerTitleStyle: {
                    fontWeight: "bold",
                    fontSize: 20,
                  },
                  headerTitleAlign: "center",
                  headerTintColor: Colors.black,
                  headerLeft: () => (
                    <Pressable
                      onPress={() => {
                        navigation.goBack();
                      }}
                    >
                      <ChevronLeftIcon
                        size="5"
                        mt="0.5"
                        marginLeft={4}
                        color={Colors.black}
                      />
                    </Pressable>
                  ),
                })}
              />
              <Stack.Screen
                name={"Result"}
                component={Result}
                options={({ navigation, route }) => ({
                  title: t("result") ?? "",
                  navigationBarColor: "white",
                  headerShadowVisible: false,
                  headerStyle: {
                    backgroundColor: "white",
                  },
                  headerTitleStyle: {
                    fontWeight: "bold",
                    fontSize: 20,
                  },
                  headerTitleAlign: "center",
                  headerTintColor: Colors.black,
                  headerLeft: () => (
                    <Pressable
                      onPress={() => {
                        if (getInitRoute().initPage == "Result") {
                          onBackPressed();
                        } else {
                          navigation.goBack();
                        }
                      }}
                    >
                      <ChevronLeftIcon
                        size="5"
                        mt="0.5"
                        marginLeft={4}
                        color={Colors.black}
                      />
                    </Pressable>
                  ),
                })}
              />
            </Stack.Navigator>
          </NavigationContainer>
        </NativeBaseProvider>
      </QueryClientProvider>
    </Provider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
